
localStorage["ws3.0"] = "1"; // Indica que a loja está usando a versão 3.0 do layout, para compatibilidade com módulos antigos
var approvalMode = true;
var notWsSign = true;

/* A11y: o popup de newsletter (app "NewsletterPopup" da Webstore) é injetado
   por JS já pronto, com role="dialog" mas sem nome acessível — o Lighthouse
   acusa "aria-dialog-name". Como o HTML não vem do tema, o rótulo é colocado
   aqui quando o nó aparece. Observer só em document.body/childList (sem
   subtree) — o app dá appendChild do container direto no body, então isso
   custa quase nada e não roda a cada mutação da página. */
(function () {
  function nameNewsletterDialog() {
    var m = document.querySelector('#modal_newsletter:not([aria-label])');
    if (m) { m.setAttribute('aria-label', 'Cadastro na newsletter'); return true; }
    return false;
  }
  function watch() {
    if (nameNewsletterDialog()) return;
    try {
      var obs = new MutationObserver(function () {
        if (nameNewsletterDialog()) obs.disconnect();
      });
      obs.observe(document.body, { childList: true });
      setTimeout(function () { obs.disconnect(); }, 20000);
    } catch (e) {}
  }
  if (document.body) watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
